import React, { useEffect, useState } from 'react';
import { CTAButton } from './ui';
import { AnimatePresence, motion } from 'framer-motion';
export const StickyMobileCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past the hero (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-365">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-sage shadow-[0_-4px_20px_rgba(0,0,0,0.05)] p-3 md:hidden" data-id="element-366">
          <div className="flex items-center justify-between gap-3" data-id="element-367">
            <div className="flex flex-col" data-id="element-368">
              <span className="font-bold text-primary text-lg leading-none" data-id="element-369">
                $39.90
              </span>
              <span className="text-xs font-medium text-accent" data-id="element-370">
                Buy 1 Get 1 Free
              </span>
            </div>
            <CTAButton className="py-3 px-6 flex-1 text-sm" data-id="element-371">
              Check Availability
            </CTAButton>
          </div>
        </motion.div>}
    </AnimatePresence>;
};